import { render, staticRenderFns } from "./EditImage.vue?vue&type=template&id=2b31e8e0&scoped=true"
import script from "./EditImage.vue?vue&type=script&lang=js"
export * from "./EditImage.vue?vue&type=script&lang=js"
import style0 from "./EditImage.vue?vue&type=style&index=0&id=2b31e8e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b31e8e0",
  null
  
)

export default component.exports